import QueryRenderer from 'relay-query-lookup-renderer';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import React from 'react';
import serverVars from 'server-vars';
import ErrorPageContent from '../components/global/ErrorPageContent/ErrorPageContent';
import { Provider } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';

function PrepareRelayQueryRenderer(props) {
    const { environment, query, variables, ignoreErrors, Component, ...otherProps } = props;
    /* eslint-disable react/prop-types, react/display-name */
    return (
        <QueryRenderer
            lookup
            query={query}
            variables={variables}
            environment={environment}
            render={({ error, props: relayData }) => {
                if (error && !ignoreErrors) {
                    return <ErrorPageContent />;
                }
                const renderProps = {
                    /**
                     * TODO INFRA: Probably dont need `isLoading`, but need to be
                     * extra careful removing it, pdp code might depend on it.
                     */
                    isLoading: !!relayData,
                    ...otherProps,
                    ...relayData,
                };
                return <Component {...renderProps} />;
            }}
        />
    );
    /* eslint-enable */
}

PrepareRelayQueryRenderer.propTypes = {
    environment: PropTypes.object.isRequired,
    query: PropTypes.func.isRequired,
    variables: PropTypes.object.isRequired,
    Component: PropTypes.func.isRequired,
    ignoreErrors: PropTypes.bool,
};

export function renderEntryComponent(options) {
    const { containerId, store, ...otherProps } = options;

    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[serverVars.get('localeDataKey')]);
    }
    ReactDOM.render(
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <Provider store={store}>
                <PrepareRelayQueryRenderer {...otherProps} />
            </Provider>
        </IntlProvider>,
        document.getElementById(containerId)
    );
}
